const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const padDatePart = (value) => String(value).padStart(2, "0");

export const formatReportDate = (value, fallback = "-") => {
  if (value === null || value === undefined || value === "") return fallback;

  const text = String(value).trim();
  const dateOnlyMatch = text.match(DATE_ONLY_PATTERN);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return `${day}-${month}-${year}`;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  return `${padDatePart(date.getDate())}-${padDatePart(date.getMonth() + 1)}-${date.getFullYear()}`;
};

export const formatReportDateRange = (value, fallback = "-") => {
  if (value === null || value === undefined || value === "") return fallback;

  const parts = String(value).split(/\s+to\s+/i);
  if (parts.length !== 2) return String(value);

  const fromDate = formatReportDate(parts[0], "");
  const toDate = formatReportDate(parts[1], "");
  return fromDate && toDate ? `${fromDate} to ${toDate}` : String(value);
};
